import { guid } from '@/mixins/guid';

export function linkShape() {
  return () => ({
    _id: guid.methods.guid(),
    title: 'Link',
    editLinkForm: false,
    newWindow: false,
    pageLink: false,
    customLink: false,
    subLinks: [],
    linkColor: 'rgba(0, 0, 0, 0.7)',
    type: 'droplet.footerNav.editorLinks',
  });
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/footer-nav/utils.js